/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{getAssetUrl as s}from"../../assets.js";function i(){return t??=(async()=>{const i=await import("../../chunks/basis_transcoder.js"),t=await i.default({locateFile:i=>s(`esri/libs/basisu/${i}`)});return t.initializeBasis(),t})(),t}let t;export{i as getBasisTranscoder};
